import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import classnames from 'classnames';
import { useVppContext } from '@vpp-frontend-components/vpp-context';
import _jsx from '@babel/runtime/helpers/jsx';
import 'prop-types';
import { Icon } from '@vpp-frontend-components/icon';
import { hyphenatedbem } from '@vpp-frontend-components/common';
var _Fragment;
const _excluded = ["className", "id", "lazyload", "src", "src2x", "carousel", "isMultimedia", "fetchPriority", "decoding", "width", "height", "alt"];
const LAZY_ON = 'on';
const LAZY_OFF = 'off';
const namespace$1 = 'ui-pdp-image';

// eslint-disable-next-line @typescript-eslint/no-redeclare
/* global window */

/**
 * Image component
 * @typedef {import('../../index').Image}
 */
const Image = _ref => {
  let {
      className = '',
      id,
      lazyload = true,
      src,
      src2x = null,
      carousel = false,
      isMultimedia = false,
      fetchPriority = null,
      decoding = 'async',
      width = null,
      height = null,
      alt = null
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    staticProps,
    dependencies
  } = useVppContext();
  const {
    lowEnd
  } = staticProps;
  const {
    BaseImage
  } = dependencies;
  const fPriority = fetchPriority ? {
    fetchpriority: fetchPriority
  } : null;
  return isMultimedia && typeof window === 'undefined' ?
  // eslint-disable-next-line react/jsx-no-useless-fragment
  _Fragment || (_Fragment = /*#__PURE__*/React.createElement(React.Fragment, null)) : /*#__PURE__*/React.createElement(BaseImage, _extends({
    className: classnames(namespace$1, className)
  }, rest, {
    carousel: carousel,
    lazyload: lazyload ? LAZY_ON : LAZY_OFF,
    lowEnd: lowEnd,
    src: src,
    srcSet: src2x ? `${src2x} 2x` : null,
    decoding: decoding,
    width: width,
    height: height,
    alt: alt
  }, fPriority));
};
const namespace = 'ui-vpp-image-component';

/**
 * Image component
 * @typedef {import('../../index').ImageComponent}
 */
const ImageComponent = _ref => {
  let {
    image_type,
    className = '',
    picture = null
  } = _ref;
  if (image_type === 'icon' && picture) {
    return /*#__PURE__*/_jsx("figure", {
      className: classnames(namespace, className)
    }, void 0, /*#__PURE__*/_jsx(Icon, {
      id: picture.id
    }));
  }
  if (image_type === 'picture' && picture) {
    return /*#__PURE__*/_jsx(Image, {
      id: picture.id,
      alt: picture.id,
      className: classnames(namespace, className),
      width: picture.width,
      height: picture.height,
      src: picture.url.src,
      src2x: picture.url.src2x
    });
  }
  return null;
};
const imageToProps = props => ({
  picture: props.picture,
  image_type: props.image_type,
  className: hyphenatedbem(props.id)
});
export { Image, ImageComponent, imageToProps };
